import { render, staticRenderFns } from "./DomainOverview.vue?vue&type=template&id=0fdcfec5&"
import script from "./DomainOverview.vue?vue&type=script&lang=js&"
export * from "./DomainOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports